import {timest} from './validate'
import {getUploadRemoteKey, INVOICE_IMAGES_FOLDER} from './fileUpload'

function cloneObject(value) {
    return JSON.parse(JSON.stringify(value));
}

function getImageSyncStatus(fileInfo, invoiceSyncStatus) {
    if (invoiceSyncStatus === 1) {
        return 1;
    }
    return fileInfo.syncStatus;
}

function getRemoteKey(innerUUID) {
    return getUploadRemoteKey(INVOICE_IMAGES_FOLDER, innerUUID);
}

function getInnerUUID(fileInfo) {
    if (fileInfo.innerUUID == null || fileInfo.innerUUID === '') {
        throw new Error('innerUUID is required for invoice image');
    }
    return fileInfo.innerUUID;
}

export function createInvoiceFileFromResponse(invoiceImage, url) {
    return {
        innerUUID: invoiceImage.innerUUID,
        attachmentDesciption: invoiceImage.detail,
        imagePath: invoiceImage.imagePath,
        attachmentName: invoiceImage.title,
        name: invoiceImage.innerUUID,
        url: url,
        syncStatus: invoiceImage.syncStatus,
        originInvoiceImage: cloneObject(invoiceImage)
    };
}

export function buildInvoiceImageForRequest(fileInfo, sortTag, invoiceSyncStatus) {
    const imageSyncStatus = getImageSyncStatus(fileInfo, invoiceSyncStatus);
    if (fileInfo.originInvoiceImage != null) {
        let invoiceImage = cloneObject(fileInfo.originInvoiceImage);
        if (fileInfo.attachmentDesciption !== invoiceImage.detail) {
            invoiceImage.detail = fileInfo.attachmentDesciption;
        }
        if (fileInfo.attachmentName !== invoiceImage.title) {
            invoiceImage.title = fileInfo.attachmentName;
        }
        if (imageSyncStatus !== invoiceImage.syncStatus) {
            invoiceImage.syncStatus = imageSyncStatus;
        }
        return invoiceImage;
    }

    const innerUUID = getInnerUUID(fileInfo);
    return {
        innerUUID: innerUUID,
        createDate: timest(),
        detail: fileInfo.attachmentDesciption == null ? "" : fileInfo.attachmentDesciption,
        imageIsNew: 0,
        imagePath: innerUUID + ".jpg",
        sortTag: sortTag,
        syncStatus: imageSyncStatus,
        title: fileInfo.attachmentName,
        accessDate: timest(),
        fromClient: 3,
        remoteKey: getRemoteKey(innerUUID),
        transferStatusRaw: 1,
        imageSchemaVersion: 1
    };
}
